import useLocalization from "#src/hooks/useLocalization";
import { useMultiStepFormContext } from "#src/hooks/useMultiStepForm";
import {
  Form,
  Panel,
  TextInput,
  useForm,
} from "@validereinc/common-components";
import { AssetType } from "@validereinc/domain";
import classNames from "classnames/bind";
import React, { useEffect } from "react";
import styles from "./NetworkForm.module.scss";
const cx = classNames.bind(styles);

const STEP_NUMBER = 1;

export const NetworkOverviewFormStep = ({
  shouldUseAssetBuilder,
}: {
  shouldUseAssetBuilder: boolean;
}) => {
  const { currentStep, updateStep } = useMultiStepFormContext();

  const { localize } = useLocalization();

  const form = useForm<{
    name: string;
  }>({
    defaultValues: {
      name: "",
    },
  });

  const formValues = form.watch();

  useEffect(() => {
    updateStep(STEP_NUMBER, {
      getValues: () => form.getValues(),
      getFormState: () => ({
        isSubmitting: false,
        isValid: Boolean(formValues.name),
      }),
    });
  }, [JSON.stringify(formValues)]);

  if (currentStep !== STEP_NUMBER) return null;

  return (
    <Panel className={cx("panel")}>
      <Form {...form}>
        <h4 className={cx("section-title")}>Overview</h4>

        {!shouldUseAssetBuilder ? (
          <p className={cx("section-description")}>
            {`Quick Create will create only the single ${localize(AssetType.ASSET_GROUP)} whose details are specified below.`}
          </p>
        ) : null}
        <div className={cx("basic-info-container")}>
          <TextInput
            label="Name"
            name="name"
            placeholder="Enter Name..."
            isFluid
            isRequired
          />
        </div>
      </Form>
    </Panel>
  );
};
